import React, { useState } from "react";
import { t } from '../../../i18n';
import { Query, Mutation } from "react-apollo";
import { FormattedMessage } from "react-intl";
import { withRouter } from "react-router-dom";
import queries from "../../../queries";
import ImageUploader from "../../uploaders/ImageUploader";
import PhotoboothCellStatsButton from "../PhotoboothCellStatsButton";
import PhotoboothCellPhotosZipButton from "../PhotoboothCellPhotosZipButton";

function PhotoboothStripePrintCellEditorWrapper(props) {
  const cell = props.cell || props.initialCellData;

  if (!cell) {
    return <p>No cell data provided.</p>;
  }

  return (
    <Query query={queries.cells.photobooth_stripe_print.get} variables={{ id: cell.id }}>
      {({ loading, error, data }) => {
        if (loading) return <p>{t('ui.common.loading')}</p>;
        if (error) return <p>Error: {error.message}</p>;
        if (!data) return null;
        return <PhotoboothStripePrintCellEditorInner initialCellData={data.photoboothStripePrintCell} />;
      }}
    </Query>
  );
}

function PhotoboothStripePrintCellEditorInner({ initialCellData }) {
  const [cellData, setCellData] = useState(initialCellData);

  if (!cellData) {
    return <p>No cell data provided.</p>;
  }

  return (
    <Mutation
      mutation={queries.cells.photobooth_stripe_print.update}
      refetchQueries={[
        { query: queries.cells.photobooth_stripe_print.get, variables: { id: cellData.id } },
      ]}
    >
      {(updateCell, { loading: mutationLoading, error: mutationError }) => (
        <>
          {mutationError && <p>Error: {mutationError.message}</p>}

          <label>
            <FormattedMessage id="projects.photobooth.stripe_print.cell.filter_uri" defaultMessage="Filter overlay" />
          </label>
          <ImageUploader
            onUpload={(uri) => setCellData({ ...cellData, filter_uri: uri })}
            value={cellData.filter_uri}
          />
          <br />

          <label>
            <FormattedMessage id="projects.photobooth.stripe_print.cell.photo_count" defaultMessage="Number of photos" />
          </label>
          <select
            value={cellData.photo_count || 4}
            onChange={(e) => setCellData({ ...cellData, photo_count: parseInt(e.target.value, 10) })}
          >
            {[2, 3, 4, 5].map((n) => (
              <option key={n} value={n}>{n}</option>
            ))}
          </select>
          <br />

          <button
            className="tsk-button"
            onClick={() => updateCell({ variables: { input: removeTypenameDeep({
              id: cellData.id,
              email: cellData.email,
              qr_code: cellData.qr_code,
              print: cellData.print,
              text_color: cellData.text_color,
              border_color: cellData.border_color,
              filter_uri: cellData.filter_uri,
              photo_count: cellData.photo_count,
            }) } })}
            disabled={mutationLoading}
          >
            {mutationLoading ? "Updating..." : "Update"}
          </button>

          <PhotoboothCellStatsButton cell={cellData} />
          <PhotoboothCellPhotosZipButton cell={cellData} />
        </>
      )}
    </Mutation>
  );
}

function removeTypenameDeep(obj) {
  if (Array.isArray(obj)) {
    return obj.map(removeTypenameDeep);
  } else if (obj !== null && typeof obj === 'object') {
    const newObj = {};
    for (const key in obj) {
      if (key !== '__typename') {
        newObj[key] = removeTypenameDeep(obj[key]);
      }
    }
    return newObj;
  }
  return obj;
}

export default withRouter(PhotoboothStripePrintCellEditorWrapper);
